import React,{createContext, useState} from 'react';

export const RowsContext= createContext();

const RowsProvider = (props) => {
    const [rows, setRows] = useState([]);
    return (
        <RowsContext.Provider
            value={{
                rows,
                setRows
            }}
        >
            {props.children}
        </RowsContext.Provider>
      );
}
 
export default RowsProvider;